import * as React from "react";
import { IAppointmentConfirmationProps } from "../Types";
import {
    renderAppointmentsList,
    renderConfirmationButtons,
    cantCheckinBecauseOfFutureAppointmentsMessage
} from "../SubComponents";
import TimeDateUtilities from "../../../constants/TimeAndDate";

export const ValidAndFutureAppointmentScenario = (props: IAppointmentConfirmationProps) => (
    <div className="text-center">
        {renderAppointmentsList(props.appointments.validAppointments, false, props)}
        {renderConfirmationButtons(true, props, props.isLoadingSpinnerActive)}
        <div style={{width: "100%"}}>
            <div className="horizontal-gray-line"/>
        </div>
        {renderAppointmentsList(props.appointments.futureAppointments, false, props)}
        <div style={{ height: "35px" }} />
        {cantCheckinBecauseOfFutureAppointmentsMessage(
            props.textString, props.appointments.futureAppointments.length > 1,
            TimeDateUtilities.getTimeStringByLanguage(
                props.appointments.futureAppointments[0].scheduledDateTime,
                props.lang,
                -props.timeBeforeToCheckIn,
                'minutes')
        )}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/Scenarios/ValidAndFutureAppointmentScenario.tsx